import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { useNavigate, useParams } from 'react-router-dom';
import './CustomerForm.css';
import Navbar from '../components/Navbar';

const CustomerForm = () => {
  const [form, setForm] = useState({
    customername: '',
    address: '',
    city: '',
    state: '',
    pincode: '',
    country: '',
    gstnumber: ''
  });

  const navigate = useNavigate();
  const { id } = useParams(); // get customer ID from URL

  useEffect(() => {
    if (id) {
      api.get(`/customers/${id}`)
        .then(res => setForm(res.data))
        .catch(err => console.error('Error fetching customer:', err));
    }
  }, [id]);

  const handleChange = e =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (id) {
        await api.put(`/customers/${id}`, form);
      } else {
        await api.post('/customers', form);
      }
      navigate('/customers');
    } catch (err) {
      console.error('Error saving customer:', err);
    }
  };

  return (
    <>
     <Navbar />
    <div className="form-container">
      <h2>{id ? 'Edit Customer' : 'Add Customer'}</h2>
      <form className="customer-form" onSubmit={handleSubmit}>
        {[
          { label: 'Customer Name', name: 'customername' },
          { label: 'Address', name: 'address' },
          { label: 'City', name: 'city' },
          { label: 'State', name: 'state' },
          { label: 'Pincode', name: 'pincode' },
          { label: 'Country', name: 'country' },
          { label: 'GST Number', name: 'gstnumber' }
        ].map(field => (
          <div className="form-group" key={field.name}>
            <label>{field.label}</label>
            <input
              type="text"
              name={field.name}
              value={form[field.name] || ''}
              onChange={handleChange}
              required
            />
          </div>
        ))}
        <div className="form-actions">
          <button type="submit" className="submit-btn">
            {id ? 'Update' : 'Add'} Customer
          </button>
        </div>
      </form>
    </div>
    </>
  );
};

export default CustomerForm;
